import { useEffect } from 'react';

import { csvImportFinishedSubject } from '../../../../store/csv-import/csv-import.observable';

// you can use the hook when you need to perform some action after the entire import process is completed.
// An example of use could be refreshing products on the website.
/**
 * @param {import('../types/import-type').ImportTypes} importType
 * @param {() => void} executableFn
 */
export const useOnImportFinished = (importType, executableFn) => {
  useEffect(() => {
    const subscription = csvImportFinishedSubject.subscribe((emittedImportType) => {
      if (emittedImportType === importType) {
        executableFn();
      }
    });
    return () => subscription.unsubscribe();
  }, [executableFn, importType]);
};
